import React, { useCallback } from 'react';
import first from 'lodash/first';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import MediaSelector from '@wix/da-shared-react/pkg/MediaPopup/MediaSelector';
import { MediaSourceType } from '@wix/da-shared-react/pkg/MediaPopup';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import { startVariation, hideStartingImageSelector } from '../../../redux/form/actions';
import { VariationSource } from '../../../redux/form/types';
/**
 * Contains the media selector opened by {@link StartingImageButton}.
 *
 * Note: This would logically reside within the associated button, but the
 * Selector contains an InputField and click events thereon would bubble up to
 * the StartingImageButton's parent (an InputField), stealing focus. [T62728]
 */ const StartingImageSelector = ({ isOpen })=>{
    const dispatchStartVariation = useAction(startVariation);
    const dispatchHideSelector = useAction(hideStartingImageSelector);
    const handleDeviationSelected = useCallback((deviations)=>{
        const deviation = first(deviations);
        if (deviation) {
            dispatchStartVariation(deviation, {
                variationSource: VariationSource.MediaSelector
            });
        }
        dispatchHideSelector();
    }, [
        dispatchStartVariation,
        dispatchHideSelector
    ]);
    const handleSelectionCancelled = useCallback(()=>{
        dispatchHideSelector();
    }, [
        dispatchHideSelector
    ]);
    return isOpen ? /*#__PURE__*/ React.createElement(MediaSelector, {
        selectionLimit: 1,
        mediaSourceTypes: [
            MediaSourceType.GALLERY,
            MediaSourceType.STASH
        ],
        allowedDeviationTypes: [
            DeviationTypes.IMAGE
        ],
        onClose: handleSelectionCancelled,
        onSelect: handleDeviationSelected,
        allowUploads: true
    }) : null;
};
StartingImageSelector.displayName = 'StartingImageSelector';
export default StartingImageSelector;

//# sourceMappingURL=StartingImageSelector.js.map